module.exports = "/_next/static/images/AV-Pro-Ad-3f3dec3adf7374efcb6a26b9b4522db2.jpg";